var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9fa8da",
    d: "M11 24L25 2 39 24 25 32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7986cb",
    d: "M25 2L39 24 25 32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9fa8da",
    d: "M11 27L25 35 39 27 25 46z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7986cb",
    d: "M25 35L39 27 25 46zM11 24L25 18 39 24 25 32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6bc0",
    d: "M25 18L39 24 25 32z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/Ethereum.44caf7f687ceac7228b187be67a0a151.svg";
export { ForwardRef as ReactComponent };